import React from 'react';
import useCssVariable from '../../../utils/useCssVariable';
import './index.scss';

export interface IMenuListProps {
  title?: string;
  subtitle?: string;
  headerImg?: string;
  headerMBImg?: string;
  children?: React.ReactNode;
  endChildren?: React.ReactNode;
}

const MenuList: React.FC<IMenuListProps> = ({
  title,
  subtitle,
  headerImg,
  headerMBImg,
  children,
  endChildren,
}: IMenuListProps) => {
  const style = useCssVariable({
    '--header-img': `url(${headerImg})`,
    '--header-mb-img': `url(${headerMBImg})`,
  });
  return (
    <div className="dui-MenuList" style={style}>
      <a className="header-img" href="https://itrail.tw" target="_blanck"></a>
      <div className="title">
        <div className="main">{title}</div>
        <div className="sub">{subtitle}</div>
      </div>
      <div className="content">
        <div className="main-content">{children}</div>
        <div className="end-content">{endChildren}</div>
      </div>
    </div>
  );
};
MenuList.displayName = 'MenuList';
export default MenuList;
